import { axiosNT } from "../../../services/axios";
import axios from "../../../services/axios";

const getRejectionCategories = () => axiosNT.get('content-validation/rejection-categories');

const getContentRatingInfo = (masterId: string) => axiosNT.get(`/content-rating/${masterId}`);

const submitContentRating = (masterId: string, payload: any) => axios.post(`/content-rating/${masterId}`, payload);

export const contentRatingServices = {
    getRejectionCategories,
    getContentRatingInfo,
    submitContentRating,
}